import { FieldTierVisibility } from './field_tier_visibility';

class FieldTierVisibilityFactory {
  constructor(template) {
    this.template = template;
  }

  make({ name, fieldOrdinal, tierInstance }) {
    const decoder = document.createElement('textarea');
    decoder.innerHTML = this.template.replace(/idx/g, fieldOrdinal)
      .replace(/tdx/g, tierInstance.ordinal);

    const fieldTierVisibilityContainer = document.createElement('div');
    fieldTierVisibilityContainer.innerHTML = decoder.value;

    const fieldTierVisibility = new FieldTierVisibility(fieldTierVisibilityContainer.firstChild);

    fieldTierVisibility.name = name;

    return fieldTierVisibility;
  }
}

export { FieldTierVisibilityFactory };
